import * as styles from "./MockBadge.css";

/**
 * Sticky corner badge that announces when MSW is intercepting API calls.
 *
 * Read-only signal so a developer can't sit in a "looks fine" UI without
 * realising they're talking to handlers instead of the real backend. Click
 * to flip `localStorage.msw` to `"off"` and reload — turns it back on by
 * setting `localStorage.msw = "on"` in the console (a reload picks up the
 * change because the SW only registers on boot — see ``app/src/main.tsx``).
 */
export function MockBadge() {
  function handleClick() {
    const next = window.confirm(
      "MSW is intercepting API calls.\n\nDisable mocks and reload to hit the real API?"
    );
    if (!next) return;
    localStorage.setItem("msw", "off");
    window.location.reload();
  }

  return (
    <div
      className={styles.badge}
      onClick={handleClick}
      title="MSW is intercepting API calls — click to disable and reload"
      role="status"
    >
      MOCKS ON · click to disable
    </div>
  );
}
